
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.835 6.714L18.026.144A.51.51 0 0017.672 0H5.112c-1.9 0-3.439 1.592-3.439 3.555v13.117H0v8.893h1.673v.802c0 1.957 1.545 3.555 3.438 3.555h16.451c1.9 0 3.438-1.592 3.438-3.555V7.103a.528.528 0 00-.165-.389zm-7.334-5.613l5.923 5.721H20.2c-1.49 0-2.699-1.167-2.699-2.597V1.101zm6.46 25.266c0 1.37-1.074 2.484-2.399 2.484H5.112c-1.326 0-2.4-1.113-2.4-2.484v-.802H14.13c2.23 0 4.03-1.993 4.03-4.446 0-2.454-1.807-4.447-4.03-4.447H2.711V3.555c0-1.37 1.075-2.484 2.4-2.484h11.352v3.154c0 2.023 1.673 3.668 3.737 3.668h3.762v18.474zM3.213 23.363v-4.488h1.753c.506 0 .903.125 1.184.383.281.257.428.592.428 1.011 0 .419-.14.76-.428 1.011-.287.252-.684.383-1.184.383h-.99v1.7h-.763zm4.293 0v-4.488h1.514c.58 0 1.05.18 1.417.532.366.353.543.814.543 1.37v.683c0 .562-.183 1.017-.543 1.37-.366.354-.837.533-1.417.533H7.505zm7.12-2.513v.598h-1.844v1.915h-.77v-4.488h2.932v.598h-2.168v1.37h1.85v.007z","fill":"#0094D9"}}),_c('path',{attrs:{"d":"M5.606 20.837a.789.789 0 00.213-.562.803.803 0 00-.213-.569c-.14-.15-.354-.227-.641-.227h-.99v1.586h.99c.287-.006.494-.078.64-.228zM9.02 19.48h-.752v3.29h.751c.367 0 .66-.12.873-.364.214-.246.324-.557.324-.94v-.688c0-.377-.11-.688-.323-.934-.214-.245-.507-.365-.874-.365z","fill":"#0094D9"}})])
          )
        }
      }
    